module.exports = {
      id: "min-circle-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.b171df2e.svg#min-circle-usage",
      toString: function () {
        return this.url;
      }
    }